import Vue from "vue";
import VueRouter from "vue-router";
import axios from "../plugins/axios";
import { i18n } from "../plugins/vue-i18n";

import Main from "../pages/client/Main.vue";
import { BoardRoutes } from "./board.router";
import { QuestionRoutes } from "./question.router";

Vue.use(VueRouter);

const routes = [
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // 사용자 페이지 라우트
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    {
        // Main 페이지
        path: "/",
        component: Main,
    },
    {
        path: "/common/kcp/cert/request",
        component: () => import("../pages/common/kcp/KCPCertRequest.vue"),
        props: true,
    },
    {
        path: "/common/kcp/cert/response",
        component: () => import("../pages/common/kcp/KCPCertResponse.vue"),
        props: true,
    },
    // {
    //     // 로그인
    //     path: "/login",
    //     component: () => import(/* webpackChunkName: "login" */ "../pages/client/login/main.vue"),
    //     props: true,
    // },
    // {
    //     // 비밀번호 찾기
    //     path: "/login/find-password",
    //     component: () => import(/* webpackChunkName: "login" */ "../pages/client/login/find-password.vue"),
    //     props: true,
    // },
    // {
    //     // 아이디 찾기
    //     path: "/login/find-id",
    //     component: () => import(/* webpackChunkName: "login" */ "../pages/client/login/find-id.vue"),
    //     props: true,
    // },
    // {
    //     // 회원가입
    //     path: "/join",
    //     component: () => import(/* webpackChunkName: "join" */ "../pages/client/join/main.vue"),
    //     props: true,
    // },
    // {
    //     // 회원가입 폼
    //     path: "/join/type",
    //     component: () => import(/* webpackChunkName: "join" */ "../pages/client/join/type.vue"),
    //     props: true,
    // },
    // {
    //     // 회원가입 폼
    //     path: "/join/form",
    //     component: () => import(/* webpackChunkName: "join" */ "../pages/client/join/form.vue"),
    //     props: true,
    // },
    // {
    //     // 회원가입 완료
    //     path: "/join/complete",
    //     component: () => import(/* webpackChunkName: "join" */ "../pages/client/join/complete.vue"),
    //     props: true,
    // },
    // {
    //     // 응찰/낙찰 내역
    //     path: "/mypage/bids-:type",
    //     component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/BidsPage.vue"),
    //     props: true,
    // },
    // {
    //     // 응찰/낙찰 내역
    //     path: "/mypage/bids-:type/:tab",
    //     component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/BidsPage.vue"),
    //     props: true,
    // },
    // {
    //     // 위탁신청내역 상세
    //     path: "/mypage/consignment-list/:_form",
    //     component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/ConsignmentViewPage.vue"),
    //     props: true,
    // },
    // {
    //     // 위탁신청내역 목록
    //     path: "/mypage/consignment-list",
    //     component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/ConsignmentListPage.vue"),
    //     props: true,
    // },
    // {
    //     // 작품문의 상세
    //     path: "/mypage/private-list/:_form",
    //     component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/PrivateViewPage.vue"),
    //     props: true,
    // },
    // {
    //     // 작품문의 목록
    //     path: "/mypage/private-list",
    //     component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/PrivateListPage.vue"),
    //     props: true,
    // },
    // {
    //     // 위탁신청
    //     path: "/mypage/consignment-form",
    //     component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/ConsignmentFormPage.vue"),
    //     props: true,
    // },
    // {
    //     // 1:1 문의
    //     path: "/mypage/question",
    //     component: () => import(/* webpackChunkName: "question" */ "../pages/client/mypage/question.vue"),
    //     children: [...QuestionRoutes],
    //     props: true,
    // },
    // {
    //     // 회원 정보 상세
    //     path: "/mypage/myinfo",
    //     component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/myinfo.vue"),
    //     props: true,
    // },
    // {
    //     // 회원 정보 변경
    //     path: "/mypage/myinfo/:tab",
    //     component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/myinfo.vue"),
    //     props: true,
    // },
    // {
    //     // 회원 탈퇴
    //     path: "/mypage/leave",
    //     component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/leave.vue"),
    //     props: true,
    // },
    // {
    //     // 회원 탈퇴
    //     path: "/mypage/leave/:tab",
    //     component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/leave.vue"),
    //     props: true,
    // },

    {
        // e커머스피칭페스타 소개
        path: "/pitching-festa",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/pitching-festa/AboutPage.vue"),
        props: true,
    },
    {
        // e커머스피칭페스타 지원 리스트
        path: "/pitching-festa/support",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/pitching-festa/SupportListPage.vue"),
        props: true,
    },
    {
        // e커머스피칭페스타 지원 뷰
        path: "/pitching-festa/support/:_id",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/pitching-festa/SupportViewPage.vue"),
        props: true,
    },
    {
        // e커머스피칭페스타 스타트업 리스트
        path: "/pitching-festa/startup",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/pitching-festa/StartupListPage.vue"),
        props: true,
    },
    {
        // e커머스피칭페스타 스타트업 뷰
        path: "/pitching-festa/startup/:_id",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/pitching-festa/StartupViewPage.vue"),
        props: true,
    },

    {
        // 유통데이터 활용 경진대회 소개
        path: "/circulation",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/circulation/AboutPage.vue"),
        props: true,
    },
    {
        // 유통데이터 활용 경진대회 지원 리스트
        path: "/circulation/support",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/circulation/SupportListPage.vue"),
        props: true,
    },
    {
        // 유통데이터 활용 경진대회 지원 뷰
        path: "/circulation/support/:_id",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/circulation/SupportViewPage.vue"),
        props: true,
    },
    {
        // 유통데이터 활용 경진대회 주요자료 리스트
        path: "/circulation/data",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/circulation/DataListPage.vue"),
        props: true,
    },
    {
        // 유통데이터 활용 경진대회 주요자료 뷰
        path: "/circulation/data/:_id",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/circulation/DataViewPage.vue"),
        props: true,
    },

    {
        // 교육·법률지원 - 교육소개
        path: "/education",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/education/AboutPage.vue"),
        props: true,
    },
    {
        // 교육·법률지원 - 교육접수 리스트
        path: "/education/receipt",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/education/ReceiptListPage.vue"),
        props: true,
    },
    {
        // 교육·법률지원 - 교육접수 뷰
        path: "/education/receipt/:_id",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/education/ReceiptViewPage.vue"),
        props: true,
    },
    {
        // 교육·법률지원 - 법률지원
        path: "/education/law",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/education/LawPage.vue"),
        props: true,
    },
    {
        // 교육·법률지원 - 법률지원
        path: "/education/law/:_id",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/education/LawViewPage.vue"),
        props: true,
    },

    {
        // 공지사항
        path: "/center/notice",
        component: () => import(/* webpackChunkName: "center" */ "../pages/client/center/notice.vue"),
        props: true,
    },
    {
        // 공지사항
        path: "/center/notice/:_notification",
        component: () => import(/* webpackChunkName: "center" */ "../pages/client/center/notice.vue"),
        props: true,
    },
    // {
    //     // Forms & Archives
    //     path: "/board/forms",
    //     component: () => import(/* webpackChunkName: "board" */ "../pages/client/board/Forms.vue"),
    //     children: [...BoardRoutes],
    //     props: true,
    // },
    // {
    //     // 서비스이용약관
    //     path: "/service-policy",
    //     component: () => import(/* webpackChunkName: "sub" */ "../pages/client/center/ServicePolicyPage.vue"),
    //     props: true,
    // },
    // {
    //     // 개인정보처리방침
    //     path: "/privacy-policy",
    //     component: () => import(/* webpackChunkName: "sub" */ "../pages/client/center/PrivacyPolicyPage.vue"),
    //     props: true,
    // },
    // {
    //     // 문의 및 제휴
    //     path: "/form/inquiry-partner",
    //     component: () => import(/* webpackChunkName: "form" */ "../pages/client/form/InquiryPartner.vue"),
    //     props: true,
    // },

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // 관리자 페이지 라우트
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    {
        // 관리자 메인
        path: "/console",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/Main.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 대시보드
        path: "/console/dashboard",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/Dashboard.vue"),
        props: true,
    },
    {
        // 관리자 - 옥션 프로그램
        path: "/console/auction-programs",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/auction/ProgramListPage.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 옥션 작품
        path: "/console/auction-works",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/auction/WorkListPage.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 옥션 작가
        path: "/console/auction-authors",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/auction/AuthorListPage.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 게시판관리
        path: "/console/boards",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/board/BoardList.vue"),
    },
    {
        // 관리자 - 게시판관리
        path: "/console/boards/create",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/board/BoardView.vue"),
    },
    {
        // 관리자 - 게시판관리
        path: "/console/boards/:_board",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/board/BoardView.vue"),
    },
    {
        // 관리자 - 폼메일관리
        path: "/console/forms",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/form/FormList.vue"),
    },
    {
        // 관리자 - 폼메일관리
        path: "/console/forms/:_form",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/form/FormView.vue"),
    },
    {
        // 관리자 - 회원등급
        path: "/console/users/levels",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/user/LevelList.vue"),
        props: true,
    },
    {
        // 관리자 - 회원등급
        path: "/console/users/withdrawals",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/user/WithdrawalList.vue"),
        props: true,
    },
    {
        // 관리자 - 사용자
        path: "/console/users",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/user/UserList.vue"),
        props: true,
    },
    {
        // 관리자 - 사용자
        path: "/console/users/create",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/user/UserView.vue"),
        props: true,
    },
    {
        // 관리자 - 사용자
        path: "/console/users/:_user",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/user/UserView.vue"),
        props: true,
    },
    {
        // 관리자 - 공지사항
        path: "/console/center/notifications",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/center/notification/NotificationList.vue"),
        props: true,
    },
    {
        // 관리자 - 공지사항 뷰
        path: "/console/center/notifications/create",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/center/notification/NotificationView.vue"),
        props: true,
    },
    {
        // 관리자 - 공지사항 뷰
        path: "/console/center/notifications/:_notification",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/center/notification/NotificationView.vue"),
        props: true,
    },
    {
        // 관리자 - FAQ
        path: "/console/center/faqs",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/center/Faq.vue"),
        props: true,
    },
    {
        // 관리자 - 1:1문의
        path: "/console/center/questions",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/center/Question.vue"),
        props: true,
    },

    {
        // 관리자 - 상품관리
        path: "/console/shop/products",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/ProductList.vue"),
        props: true,
    },
    {
        // 관리자 - 상품 생성
        path: "/console/shop/products/create",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/ProductView.vue"),
        props: true,
    },
    {
        // 관리자 - 상품 복사
        path: "/console/shop/products/copy",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/ProductView.vue"),
        props: true,
    },
    {
        // 관리자 - 상품 view
        path: "/console/shop/products/:_product",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/ProductView.vue"),
        props: true,
    },
    {
        // 관리자 - 카테고리
        path: "/console/shop/categories",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/shop/CategoryList.vue"),
        props: true,
    },

    {
        // 관리자 - 서비스 이용약관
        path: "/console/terms",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/terms/TermsList.vue"),
        props: true,
    },
    {
        // 관리자 - 배너
        path: "/console/banners",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/banner/BannerList.vue"),
        props: true,
    },
    {
        // 관리자 - 배너
        path: "/console/banners/create",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/banner/BannerView.vue"),
        props: true,
    },
    {
        // 관리자 - 배너
        path: "/console/banners/:_banner",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/banner/BannerView.vue"),
        props: true,
    },
    {
        // 관리자 - 팝업
        path: "/console/popups",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/popup/PopupList.vue"),
        props: true,
    },
    {
        // 관리자 - 설정
        path: "/console/setting",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/setting/SettingView.vue"),
        props: true,
    },
    {
        // 관리자 - 비밀번호
        path: "/console/password",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/setting/PasswordView.vue"),
        props: true,
    },
    {
        path: "/console/kea/e-festa",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/kea/e-festa/index.vue"),
        props: true,
    },
    {
        path: "/console/kea/applications",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/kea/applications/index.vue"),
        props: true,
    },
    {
        path: "/console/kea/applications/create",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/kea/applications/__id.vue"),
        props: true,
    },
    {
        path: "/console/kea/applications/:_id",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/kea/applications/__id.vue"),
        props: true,
    },
    {
        path: "/console/kea/startups",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/kea/startups/index.vue"),
        props: true,
    },
    {
        path: "/console/kea/startups/create",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/kea/startups/__id.vue"),
        props: true,
    },
    {
        path: "/console/kea/startups/:_id",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/kea/startups/__id.vue"),
        props: true,
    },
    {
        path: "/console/kea/configs",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/kea/configs/index.vue"),
        props: true,
    },
    {
        path: "/console/circulation/e-festa",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/circulation/e-festa/index.vue"),
        props: true,
    },
    {
        path: "/console/circulation/applications",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/circulation/applications/index.vue"),
        props: true,
    },
    {
        path: "/console/circulation/applications/create",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/circulation/applications/__id.vue"),
        props: true,
    },
    {
        path: "/console/circulation/applications/:_id",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/circulation/applications/__id.vue"),
        props: true,
    },
    {
        path: "/console/circulation/datas",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/circulation/datas/index.vue"),
        props: true,
    },
    {
        path: "/console/circulation/datas/create",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/circulation/datas/__id.vue"),
        props: true,
    },
    {
        path: "/console/circulation/datas/:_id",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/circulation/datas/__id.vue"),
        props: true,
    },
    {
        path: "/console/circulation/configs",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/circulation/configs/index.vue"),
        props: true,
    },
    {
        path: "/console/education/e-festa",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/education/e-festa/index.vue"),
        props: true,
    },
    {
        path: "/console/education/applications",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/education/applications/index.vue"),
        props: true,
    },
    {
        path: "/console/education/applications/create",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/education/applications/__id.vue"),
        props: true,
    },
    {
        path: "/console/education/applications/:_id",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/education/applications/__id.vue"),
        props: true,
    },
    {
        path: "/console/legal/e-festa",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/legal/e-festa/index.vue"),
        props: true,
    },
    {
        path: "/console/legal/applications",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/legal/applications/index.vue"),
        props: true,
    },
    {
        path: "/console/legal/applications/create",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/legal/applications/__id.vue"),
        props: true,
    },
    {
        path: "/console/legal/applications/:_id",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/legal/applications/__id.vue"),
        props: true,
    },
    {
        path: "/console/main/award",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/main/award/index.vue"),
        props: true,
    },
    {
        path: "/console/main/award/create",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/main/award/__id.vue"),
        props: true,
    },
    {
        path: "/console/main/award/:_id",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/main/award/__id.vue"),
        props: true,
    },
    {
        path: "/developer/kea/e-festa",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/developer/kea/e-festa/index.vue"),
        props: true,
    },
    {
        path: "/developer/converter",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/developer/converter.vue"),
        props: true,
    },
    {
        path: "/developer/kea/applications",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/developer/kea/applications/index.vue"),
        props: true,
    },
    {
        path: "/developer/kea/applications/none",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/developer/kea/applications/__id.vue"),
        props: true,
    },
    {
        path: "/developer/kea/applications/:_id",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/developer/kea/applications/__id.vue"),
        props: true,
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,

    scrollBehavior: (to, from, savedPosition) => {
        let scrollTo = undefined;

        if (to.hash) {
            scrollTo = to.hash;
        } else if (savedPosition) {
            scrollTo = savedPosition.y;
        }

        if (scrollTo != undefined) return {
            selector: scrollTo,
            behavior: "smooth"
        }
    },
    
});

router.beforeEach((to, from, next) => {
    try {
        const accessToken = sessionStorage.getItem("accessToken");
        axios.defaults.headers.common["Authorization"] = !!accessToken ? `Bearer ${accessToken}` : "";
        axios.defaults.headers.common["Accept-Language"] = i18n.locale;

        const route = routes.find((route) => route.path == to.path);
        if (!route?.scope) next();
        else {
            if (!accessToken) {
                if (0 <= to.path.indexOf("console")) {
                    next();
                    return;
                } else throw new Error("로그인 후 이용가능합니다");
            }

            const payload = JSON.parse(atob(accessToken.split(".")[1]));
            const scope = payload?.scope || [];

            if (!scope.find((scope) => route.scope.includes(scope))) {
                throw new Error("접근권한이 없습니다");
            }

            next();
        }
    } catch (error) {
        alert(error.message);
        window.location.href = routes.find((route) => route.path == from.path)?.path ?? routes.find((route) => route.path == "/")?.path ?? "about:blank";
    }
});

export default router;
